/*
 * Copyright (C) 2026 - present Marek Kuzora - All Rights Reserved.
 */


import Logic from 'fierry/data/logic';

import HexGroup from 'solis/type/hex/group';
import HexFrontier from 'solis/type/hex/frontier';

import BoardFrontierType from 'solis/logic/board/frontier.type';


export default class BoardSectorGeometry extends Logic
{
  getZoneGroup (type)
  {
    const zoneUnderControl = (zone) =>
    {
      return this.getFrontierUser(zone, type) === this.cass.currentUser;
    };

    const zoneToAbsoluteCoords = (zone) =>
    {
      return zone.getAbsoluteHex();
    };

    return new HexGroup(this.object.getZones().values().filter(zoneUnderControl).map(zoneToAbsoluteCoords));
  }


  getZoneFrontier (type)
  {
    const user = this.cass.currentUser;

    const filterCallback = (hex) =>
    {
      const zone = this.object.getBoard().getZone(hex);

      return zone !== null && this.getFrontierUser(zone, type) === user;
    };

    return new HexFrontier(this.getZoneGroup(type), filterCallback);
  }


  getFrontierUser (zone, type)
  {
    switch (type)
    {
      case BoardFrontierType.Sector: return zone.getSector().cass.currentUser;
      case BoardFrontierType.Zone:   return zone.cass.currentUser;
    }
  }


};
